import { useMovedBankAccountToAnotherCompanyMutation } from '../../../Store/bankaccount';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { changeToasterState, toggleModal } from '../../../Store/layoutSlice';
import { companyListSelector, currentBankAccountSelector, currentCompanySelector } from '../../../Store/paramsBagSlice';
import { useState } from 'react';
import { createSelectorOptionsFromCompanies } from './BankAccountMoveFormUtil';
import { TOASTER_STATE } from '../../../Model/Enums';
import { Company } from '../../../Model/Company';

export const useBankAccountMoveForm = () => {
  const dispatch = useAppDispatch();
  const [options, setOptions] = useState(null);
  const currentCompany = useAppSelector(currentCompanySelector);
  const companies = createSelectorOptionsFromCompanies(
    (useAppSelector(companyListSelector) as Company[])?.filter((company) => company._id !== currentCompany._id)
  );

  const [moveBankAccount, { isLoading }] = useMovedBankAccountToAnotherCompanyMutation();
  const currentBankAccount = useAppSelector(currentBankAccountSelector);

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      await moveBankAccount({
        accountNr: currentBankAccount?.accountNr,
        originate: currentBankAccount?.originate,
        sourceCompanyId: currentCompany?._id,
        targetCompanyId: options?.value,
      }).unwrap();
    } catch (error) {
      dispatch(changeToasterState(TOASTER_STATE.MOVE_COMPANY_FAILED));
    } finally {
      dispatch(toggleModal());
    }
  };

  const onClose = () => {
    dispatch(toggleModal());
  };

  return {
    onSubmit,
    isLoading,
    onClose,
    setOptions,
    companies,
  };
};
